import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { AttributeValuesChecklist, ColorsFilter, TagsFilter } from "@components/molecules";
import { AttributeChoiceTypeEnum } from "gqlTypes/globalTypes";
import React from "react";
import { Range } from "../../atoms";

var checkIfAttributeIsChecked = function checkIfAttributeIsChecked(filters, value, slug) {
  // TODO: fixed eslint error. Check it.
  // if (filters!.attributes && filters.attributes.hasOwnProperty(slug)) {
  if (filters.attributes && slug in filters.attributes) {
    if (filters.attributes[slug].find(function (filter) {
      return filter === value.slug;
    })) {
      return true;
    }

    return false;
  }

  return false;
};

var withSelected = function withSelected(filters, values, slug) {
  return values.map(function (value) {
    return _objectSpread({}, value, {
      selected: checkIfAttributeIsChecked(filters, value, slug)
    });
  }).filter(function (attr) {
    return attr.slug !== "values" && attr.slug !== "inputtype";
  });
}; // TODO: temp DB fix


export function AttributeTypeFilterInput(_ref) {
  var choiceType = _ref.choiceType,
      onAttributeFiltersChange = _ref.onAttributeFiltersChange,
      filters = _ref.filters,
      values = _ref.values,
      slug = _ref.slug;

  if (choiceType === AttributeChoiceTypeEnum.SLIDER) {
    return React.createElement(Range, {
      values: withSelected(filters, values, slug),
      onChange: function onChange(value) {
        onAttributeFiltersChange(slug, value);
      }
    });
  }

  if (choiceType === AttributeChoiceTypeEnum.SWATCH) {
    return React.createElement(ColorsFilter, {
      name: slug,
      values: withSelected(filters, values, slug),
      onValueClick: function onValueClick(value) {
        return onAttributeFiltersChange(slug, value.slug);
      }
    });
  }

  if (choiceType === AttributeChoiceTypeEnum.DROPDOWN) {
    return React.createElement(TagsFilter, {
      name: slug,
      values: withSelected(filters, values, slug),
      onValueClick: function onValueClick(value) {
        return onAttributeFiltersChange(slug, value.slug);
      }
    });
  }

  return (// fallback to checklist
    React.createElement(AttributeValuesChecklist, {
      name: slug,
      values: withSelected(filters, values, slug),
      onValueClick: function onValueClick(value) {
        return onAttributeFiltersChange(slug, value.slug);
      }
    })
  );
}